export default __webpack_public_path__ + "static/media/grasp_and_place_responsive.bf2cffb5.png";